/**
 * @generated SignedSource<<5a4a62c55ef7ce8878f88110be10cc7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedEditorialArticles_refactor_item$data = {
  readonly storyTellingModule: {
    readonly tabs: ReadonlyArray<{
      readonly supplementaryEditorial: {
        readonly articles: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"EditorialModuleArticles_articles">;
        }> | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PdpSharedEditorialArticles_refactor_item";
};
export type PdpSharedEditorialArticles_refactor_item$key = {
  readonly " $data"?: PdpSharedEditorialArticles_refactor_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedEditorialArticles_refactor_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedEditorialArticles_refactor_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WordpressArticlesType",
              "kind": "LinkedField",
              "name": "supplementaryEditorial",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WordpressArticleType",
                  "kind": "LinkedField",
                  "name": "articles",
                  "plural": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "EditorialModuleArticles_articles"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "1778d75190f2899c589eb2d07936fdb2";

export default node;
